import { render, staticRenderFns } from "./VCabecalhoBtn.vue?vue&type=template&id=01220aed"
import script from "./VCabecalhoBtn.vue?vue&type=script&lang=js"
export * from "./VCabecalhoBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports